{
	"experimental": "EXPERIMENTAL",
	"togglePanel": "Toggle {{name}} Panel",
	"ariaPanel": "{{name}} Panel"
}
